import styles from "./StakeModal.module.scss";
import React, { ReactElement } from "react";
import { Group, Stack } from "@mantine/core";

export default function StakeModal(): ReactElement | null {
  return (
    <div className={styles.modalContent}>
      <div className={styles.modalHeader}>
        <span>Staking in 5 simple steps</span>
      </div>

      <Stack>
        <Group gap={"xs"} wrap={"nowrap"}>
          <div className={styles.bulletPoint}>1</div>
          <div className={styles.bulletText}>
            Buy FLR on exchanges (like OKX, Gate.io, Kraken, Bitstamp, etc.)
          </div>
        </Group>
        <Group gap={"xs"} wrap={"nowrap"}>
          <div className={styles.bulletPoint}>2</div>
          <div className={styles.bulletText}>
            Send it to hot/cold wallet (like{" "}
            <a
              href={"https://flare.space/learn/creating-a-wallet"}
              target="_blank"
              rel="noreferrer"
            >
              Metamask
            </a>
            , Ledger, etc.)
          </div>
        </Group>
        <Group gap={"xs"} wrap={"nowrap"}>
          <div className={styles.bulletPoint}>3</div>
          <div className={styles.bulletText}>
            Go to{" "}
            <a
              href={"https://portal.flare.network/staking"}
              target="_blank"
              rel="noreferrer"
            >
              https://portal.flare.network/staking
            </a>{" "}
            and connect to your wallet
          </div>
        </Group>
        <Group gap={"xs"} wrap={"nowrap"}>
          <div className={styles.bulletPoint}>4</div>
          <div className={styles.bulletText}>
            Deposit and stake for at least 14 days (locking your asset)
          </div>
        </Group>
        <Group gap={"xs"} wrap={"nowrap"}>
          <div className={styles.bulletPoint}>5</div>
          <div className={styles.bulletText}>
            Claim your rewards on{" "}
            <a
              href={"https://portal.flare.network/staking"}
              target="_blank"
              rel="noreferrer"
            >
              https://portal.flare.network
            </a>{" "}
            (Note: available every 14 days)
          </div>
        </Group>
        <div className={styles.footerLink}>
          See video for details:{" "}
          <a
            href={
              "https://www.youtube.com/watch?v=41JAImHUzGY&ab_channel=Flare"
            }
            target="_blank"
            rel="noreferrer"
          >
            link
          </a>
        </div>
      </Stack>
    </div>
  );
}
